import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./diff.scss";

import axios from 'util/axios';

import { useTranslation } from "react-i18next";

import diff_match_patch from "./Functions/diff-match-patch";

/*
  IMPORT
*/

import { Master, RevisionSelect, RenderTables } from "./components.js";
import {useLocation} from "react-router-dom";


// eslint-disable-next-line react-hooks/rules-of-hooks


const getSheetInfo = async (args) => {
    try {
        args?.dispatch({ type: "LOADING_ON" });

        const response = await axios.post(
            process.env.REACT_APP_API + "/diff/selectPcsSheet",
            args?.postData,
            {
                headers: {
                    "Cache-Control": "no-store",
                    Pragma: "no-store",
                    Expires: "0",
                },
            }
        );

        const result = response.data.data.result;

        args?.SetSheetInfo(result);
    } catch (e) {
        console.error(e);
    } finally {
        args?.dispatch({ type: "LOADING_OFF" });
    }
};




const DiffDetail = () => {
    const { t } = useTranslation(["page"]);
    const dispatch = useDispatch();

    const userSelector = useSelector((store) => store.user);

    const [SheetInfo, SetSheetInfo] = useState();
    const [TableData, SetTableData] = useState();
    const data = useLocation().state;
    const [ShCd, SetShCd] = useState();



    const MasterFunc = {
        getSheetCd: (MasterValue) => {
            SetSheetInfo(null);
            getSheetInfo({ postData: MasterValue, SetSheetInfo, dispatch,ShCd });
        },
        changed: () => {
            SetSheetInfo(null);
        },
    };

    const RevisionFunc = {
        getTableData: (data) => {
            SetTableData((OLD) => ({
                ...OLD,
                sheetcd: SheetInfo?.sheetCode,
                ...data,
                compare: null,
            }));
        },
        compare: () => {
            SetTableData((OLD) => ({ ...OLD, compare: true }));
        },
        initial: () => {
            SetTableData(null);
        },
    };

    

    useEffect(() => {
        
        
        return () => {
            SetSheetInfo(null);
        };
    }, []);

    return (
        <section className="detail2" style={{ marginTop: "30px" }}>
            <Master data={SheetInfo} funcs={MasterFunc} shcd={ShCd} />
            {!!SheetInfo && <RevisionSelect sheetData={SheetInfo} funcs={RevisionFunc} />}
            {!!TableData && <RenderTables tableData={TableData} />}
        </section>
    );

};

export default DiffDetail;
